import { popperGenerator as r, eventListeners as e, popperOffsets as o, computeStyles as p, applyStyles as t, offset as f, flip as i, preventOverflow as s, arrow as a, hide as m } from "@popperjs/core";
import l from "popper-max-size-modifier";
import d from "./arrowOffset.mjs";
import { applyMaxSize as n } from "./modifiers/applyMaxSize.mjs";
import { cursorAnchoringModifier as c } from "./modifiers/cursorAnchoring.mjs";
var u = [e, c, o, p, t, f, i, s, a, d, m, l, n];
const x = r({
  defaultModifiers: u
});
export {
  x as default
};
